import _ from 'lodash';
import { arrayPush } from 'redux-form';

import { NotificationTheme } from '../../../constants/notification';
import { NotificationsTranslationKeys } from '../../../containers/notifications/notifications-keys';
import { getSelectedProjectId } from '../../../redux/projects/projects.selectors';
import { Dispatch, GetState } from '../../../redux/redux.types';
import { getSelectedOrganizationId } from '../../../selectors/organizations/organizations';
import { projectService } from '../../../transport';
import { teamMembersService } from '../../../transport/services/team-members-service';
import { errorLogger } from '../../../utils/error-logger/error-logger';
import { BI_ERRORS } from '../../../utils/statistics/bi-error-logger/bi-errors';
import { generateTeamMembersData } from '../../team/team-member-modal/team-member-form/team-member-form.utils';
import {
  deleteTeamInvitationById,
  noTeamMemberIdError,
  teamMemberDeleteError,
} from '../../team/team-members-list/team-members-list.actions';
import {
  closeTeamMemberAddModal,
  TEAM_MEMBERS_ACTION_NAMES,
} from '../../team/team.actions';
import {
  TeamMemberFormAccessLevel,
  TeamMemberFormAccessPermissions,
} from '../../team/team.constants';
import { TeamMemberSecurityGroup } from '../../team/team.types';
import { PROJECT_OVERVIEW_MEMBERS_EDIT_MEMBER_FORM } from './project-overview-members-edit-member-form/project-overview-members-edit-member-form';
import {
  getProjectOverviewMembersDeletingMember,
  getProjectOverviewMembersDeletingMemberId,
} from './project-overview-members.selectors-ui';
import { ProjectOverviewMembersAddMemberFormValues } from './project-overview-members.types';
import { generateMemberSecurityGroupsData } from './project-overview-members.utils';
import { addTeamMemberSuccess } from '../../team/team-member-modal/team-member-form/team-member-form.actions';

export const PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES = {
  OPEN_ADD_MEMBER_MODAL_FROM_MEMBERS_LIST_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__OPEN_ADD_MEMBER_MODAL_FROM_MEMBERS_LIST_MODAL',
  OPEN_ADD_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__OPEN_ADD_MEMBER_MODAL',
  CLOSE_ADD_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__CLOSE_ADD_MEMBER_MODAL',

  OPEN_DELETE_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__OPEN_DELETE_MEMBER_MODAL',
  CLOSE_DELETE_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__CLOSE_DELETE_MEMBER_MODAL',
  OPEN_DELETE_MEMBER_MODAL_FROM_EDIT_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__OPEN_DELETE_MEMBER_MODAL_FROM_EDIT_MEMBER_MODAL',

  OPEN_EDIT_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__OPEN_EDIT_MEMBER_MODAL',
  CLOSE_EDIT_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__CLOSE_EDIT_MEMBER_MODAL',

  OPEN_MEMBERS_LIST_MODAL_FROM_ADD_MEMBER_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__OPEN_MEMBERS_LIST_MODAL_FROM_ADD_MEMBER_MODAL',
  OPEN_MEMBERS_LIST_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__OPEN_MEMBERS_LIST_MODAL',
  CLOSE_MEMBERS_LIST_MODAL:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__CLOSE_MEMBERS_LIST_MODAL',

  UPDATE_MEMBER_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__UPDATE_MEMBER_SUCCESS',
  UPDATE_MEMBER_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__UPDATE_MEMBER_ERROR',

  UPDATE_MEMBERS_LIST_MEMBER_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__UPDATE_MEMBERS_LIST_MEMBER_SUCCESS',
  UPDATE_MEMBERS_LIST_MEMBER_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__UPDATE_MEMBERS_LIST_MEMBER_ERROR',

  UPDATE_MEMBERS_LIST_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__UPDATE_MEMBERS_LIST_SUCCESS',
  UPDATE_MEMBERS_LIST_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__UPDATE_MEMBERS_LIST_ERROR',

  REMOVE_INVITATION_PERMISSIONS_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__REMOVE_INVITATION_PERMISSIONS_SUCCESS',
  REMOVE_INVITATION_PERMISSIONS_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__REMOVE_INVITATION_PERMISSIONS_ERROR',

  REMOVE_MEMBER_PERMISSIONS_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__REMOVE_MEMBER_PERMISSIONS_SUCCESS',
  REMOVE_MEMBER_PERMISSIONS_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__REMOVE_MEMBER_PERMISSIONS_ERROR',

  SEND_PROJECT_INVITATION_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__SEND_PROJECT_INVITATION_SUCCESS',
  SEND_PROJECT_INVITATION_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__SEND_PROJECT_INVITATION_ERROR',

  ADD_INVITATION_TO_PROJECT_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__ADD_INVITATION_TO_PROJECT_SUCCESS',
  ADD_INVITATION_TO_PROJECT_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__ADD_INVITATION_TO_PROJECT_ERROR',

  ADD_MEMBER_TO_PROJECT_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__ADD_MEMBER_TO_PROJECT_SUCCESS',
  ADD_MEMBER_TO_PROJECT_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__ADD_MEMBER_TO_PROJECT_ERROR',

  ADD_MEMBERS_TO_PROJECT_SUCCESS:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__ADD_MEMBERS_TO_PROJECT_SUCCESS',
  ADD_MEMBERS_TO_PROJECT_ERROR:
    'PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES__ADD_MEMBERS_TO_PROJECT_ERROR',
};

export const openProjectOverviewMembersAddMemberModalFromMembersListModal =
  () => ({
    type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_ADD_MEMBER_MODAL_FROM_MEMBERS_LIST_MODAL,
    payload: undefined,
  });

export const openProjectOverviewMembersAddMemberModal = () => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_ADD_MEMBER_MODAL,
  payload: undefined,
});

export const closeProjectOverviewMembersAddMemberModal = () => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_ADD_MEMBER_MODAL,
  payload: undefined,
});

export const openProjectOverviewMembersDeleteMemberModal = (
  memberId: string,
) => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_DELETE_MEMBER_MODAL,
  payload: memberId,
});

export const closeProjectOverviewMembersDeleteMemberModal = () => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_DELETE_MEMBER_MODAL,
  payload: undefined,
});

export const openProjectOverviewMembersDeleteMemberModalFromEditMemberModal =
  () => ({
    type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_DELETE_MEMBER_MODAL_FROM_EDIT_MEMBER_MODAL,
    payload: undefined,
  });

export const openProjectOverviewMembersEditMemberModal = (
  memberId: string,
) => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_EDIT_MEMBER_MODAL,
  payload: memberId,
});

export const closeProjectOverviewMembersEditMemberModal = () => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_EDIT_MEMBER_MODAL,
  payload: undefined,
});

export const openProjectOverviewMembersListModalFromAddMemberModal = () => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_MEMBERS_LIST_MODAL_FROM_ADD_MEMBER_MODAL,
  payload: undefined,
});

export const openProjectOverviewMembersListModal = () => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.OPEN_MEMBERS_LIST_MODAL,
  payload: undefined,
});

export const closeProjectOverviewMembersListModal = () => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.CLOSE_MEMBERS_LIST_MODAL,
  payload: undefined,
});

const removeCurrentProjectPermissionsFromInvitationSuccess = (payload: {
  memberId: string;
  securityGroups: string[];
}) => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.REMOVE_INVITATION_PERMISSIONS_SUCCESS,
  payload,
  notification: {
    key: NotificationsTranslationKeys.projectOverviewMembersRemoveMemberPermissionsSuccess,
    theme: NotificationTheme.Success,
  },
});

const removeCurrentProjectPermissionsFromInvitationError = (reason) => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.REMOVE_INVITATION_PERMISSIONS_ERROR,
  payload: reason,
  notification: {
    key: NotificationsTranslationKeys.projectOverviewMembersRemoveInvitationPermissionsError,
    theme: NotificationTheme.Error,
  },
});

const addInvitationToProjectError = (reason) => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.ADD_INVITATION_TO_PROJECT_ERROR,
  payload: reason,
  notification: {
    key: NotificationsTranslationKeys.projectOverviewMembersAddInvitationToProjectError,
    theme: NotificationTheme.Error,
  },
});

const addMembersToProjectError = (amount: number) => ({
  type: PROJECT_OVERVIEW_MEMBERS_ACTION_NAMES.ADD_MEMBERS_TO_PROJECT_ERROR,
  payload: undefined,
  notification: {
    key: NotificationsTranslationKeys.projectOverviewMembersAddMembersToProjectError,
    theme: NotificationTheme.Error,
    options: {
      amount,
    },
  },
});

export const addProjectOverviewMembersEditMemberFormAccess =
  () =>
  (dispatch: Dispatch): void => {
    dispatch(
      arrayPush(PROJECT_OVERVIEW_MEMBERS_EDIT_MEMBER_FORM, 'securityGroups', {
        level: undefined,
        permissions: TeamMemberFormAccessPermissions.Viewer,
        projectsIds: [],
      }),
    );
  };

export const addMembersToProject =
  (values: ProjectOverviewMembersAddMemberFormValues) =>
  async (dispatch: Dispatch, getState: GetState): Promise<void> => {
    const state = getState();

    const projectId = getSelectedProjectId(state);
    const organizationId = getSelectedOrganizationId(state);

    const { emails, securityGroups } = generateTeamMembersData({
      emails: values.emails,
      securityGroups: [
        {
          level: TeamMemberFormAccessLevel.Project,
          permissions: values.permissions,
          projectsIds: [projectId],
        },
      ],
    });

    try {
      await Promise.all(
        _.map(emails, async (email: string) => {
          try {
            await projectService.inviteProjectMember({
              organizationId,
              projectId,
              member: {
                email,
                securityGroups,
              },
            });
          } catch ({ response }) {
            dispatch(addInvitationToProjectError(_.get(response, 'data')));

            errorLogger.logError({
              errorDescription:
                BI_ERRORS.projectOverviewTeamMembers
                  .addInvitationToProjectFailed,
              otherParams: { response },
            });

            return Promise.reject(response);
          }
        }),
      );

      emails.forEach((email) => {
        dispatch(addTeamMemberSuccess({ email, securityGroups }));
      });
      dispatch(closeTeamMemberAddModal());

      setTimeout(async () => {
        await reloadMembersAndInvitations(dispatch, organizationId, projectId);
      }, 200);
    } catch (e) {
      dispatch(addMembersToProjectError(_.size(emails)));
    }
  };

async function reloadMembersAndInvitations(
  dispatch: Dispatch,
  organizationId: string,
  projectId: string,
) {
  await Promise.all([
    dispatch({
      types: [
        TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_START,
        TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_SUCCESS,
        TEAM_MEMBERS_ACTION_NAMES.GET_INVITATIONS_MEMBERS_FOR_PROJECT_ERROR,
      ],
      callApi: () =>
        teamMembersService.getInvitations({ organizationId, projectId }),
    }),
    dispatch({
      types: [
        TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_FOR_PROJECT_START,
        TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_FOR_PROJECT_SUCCESS,
        TEAM_MEMBERS_ACTION_NAMES.GET_TEAM_MEMBERS_FOR_PROJECT_ERROR,
      ],
      callApi: () =>
        teamMembersService.getTeamMembersForProject({
          organizationId,
          projectId,
        }),
    }),
  ]);
}

export const removeMemberFromCurrentProject =
  () => async (dispatch: Dispatch, getState: GetState) => {
    const state = getState();

    const memberId = getProjectOverviewMembersDeletingMemberId(state);
    const member = getProjectOverviewMembersDeletingMember(state);
    const organizationId = getSelectedOrganizationId(state);
    const projectId = getSelectedProjectId(state);

    if (!memberId) {
      dispatch(teamMemberDeleteError(noTeamMemberIdError));
      throw new Error(noTeamMemberIdError);
    }

    if (!member) {
      await dispatch(deleteTeamInvitationById(memberId));
      dispatch(closeProjectOverviewMembersDeleteMemberModal());
      return;
    }

    const updatedSecurityGroups: TeamMemberSecurityGroup[] = _.filter(
      member?.securityGroups,
      (securityGroup: TeamMemberSecurityGroup) => {
        return (
          !securityGroup.projectId || securityGroup.projectId !== projectId
        );
      },
    );

    dispatch(closeProjectOverviewMembersDeleteMemberModal());
    try {
      await projectService.removeProjectMember({
        organizationId,
        projectId,
        memberId: member.id,
      });

      dispatch(
        removeCurrentProjectPermissionsFromInvitationSuccess({
          memberId: member.id,
          securityGroups: generateMemberSecurityGroupsData(
            updatedSecurityGroups,
          ),
        }),
      );

      setTimeout(async () => {
        await reloadMembersAndInvitations(dispatch, organizationId, projectId);
      }, 200);
    } catch ({ response }) {
      dispatch(
        removeCurrentProjectPermissionsFromInvitationError(
          _.get(response, 'data'),
        ),
      );

      errorLogger.logError({
        errorDescription:
          BI_ERRORS.projectOverviewTeamMembers
            .removeMembersListInvitationPermissionsFailed,
        otherParams: { response },
      });
    }
  };
